
@if (isLoading$ | async) {
<div class="fixed inset-0 z-50 flex items-center justify-center" style="background-color: rgba(39, 43, 52, 0.24);">
  <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-g300"></div>
</div>
}
